import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isEmpty } from 'validate.js';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import { FILTER_SIZE } from 'dpl/constants/query_params';
import {
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';

import FilterPill from './FilterPill';
import ExposedFilterBottomModal from './ExposedFilterBottomModal';
import ExposedFilterDropdown from './ExposedFilterDropdown';
import MultiSelectChecklistFilter from './MultiSelectChecklistFilter';

const IS_LT_MD = isLessThanBreakpoint('md');

const FILTER_TITLE = 'Filter by size';

export default function SizeFilterButton({ resultsType, totalItemCount }) {
  const { server, queryParams } = useSelector(state => state);
  const { breedSizes } = server;
  const isSelected = Boolean(queryParams[FILTER_SIZE]);
  const [isSizeFilterOpen, setIsSizeFilterOpen] = useState(false);

  const analytics = {
    button_cta: 'size',
    view: ANALYTICS_VIEWS.PUPPY_SEARCH_RESULTS,
    view_feature: ANALYTICS_VIEW_FEATURES.COAT_TYPE_FILTER_BUTTON,
    view_feature_location: ANALYTICS_VIEW_FEATURE_LOCATIONS.SEARCH_HEADER
  };

  const FilterButton = (
    <FilterPill
      onClick={() => setIsSizeFilterOpen(true)}
      label="Size"
      displayDropdownArrow
      isSelected={isSelected}
      analytics={analytics}
      isOpen={isSizeFilterOpen}
    />
  );

  if (isEmpty(breedSizes)) {
    return null;
  }

  if (IS_LT_MD) {
    return (
      <>
        {FilterButton}
        <ExposedFilterBottomModal
          isFilterMenuOpen={isSizeFilterOpen}
          setIsFilterMenuOpen={setIsSizeFilterOpen}
          resultsType={resultsType}
          totalItemCount={totalItemCount}
          title={FILTER_TITLE}
        >
          <MultiSelectChecklistFilter
            filterParam={FILTER_SIZE}
            filterOptions={breedSizes}
          />
        </ExposedFilterBottomModal>
      </>
    );
  }

  return (
    <ExposedFilterDropdown
      isOpen={isSizeFilterOpen}
      setIsOpen={setIsSizeFilterOpen}
      toggleButton={FilterButton}
      title={FILTER_TITLE}
      setIsMenuOpen={() => setIsSizeFilterOpen(false)}
      totalItemCount={totalItemCount}
      resultsType={resultsType}
    >
      <div className="mb4">
        <MultiSelectChecklistFilter
          filterParam={FILTER_SIZE}
          filterOptions={breedSizes}
        />
      </div>
    </ExposedFilterDropdown>
  );
}
SizeFilterButton.propTypes = {
  resultsType: PropTypes.string.isRequired,
  totalItemCount: PropTypes.number.isRequired
};
